import { isMobileOnly } from 'react-device-detect';

export const useStyles = () => ({
  root: {
    display: 'grid',
    gridTemplateColumns: isMobileOnly ? 'repeat(7, 32px)' : 'repeat(5, 48px)',
    gap: 2,
    justifyContent: isMobileOnly ? 'space-between' : 'center',
    '& img': {
      width: '100%',
      height: 'auto',
      cursor: 'pointer',
    },
  },
});
